import type {WidgetType} from "constants/WidgetConstants";
import * as React from "react";
import type {WidgetProps, WidgetState} from "widgets/BaseWidget";
import TaroWidget from "widgetsTaro";
import {ValidationTypes} from "constants/WidgetValidation";
import type {Stylesheet} from "entities/AppTheming";
import {DefaultAutocompleteDefinitions} from "widgets/WidgetUtils";
import type {AutocompletionDefinitions} from "widgets/constants";
import TRadioWidget from "../component";
import {DerivedPropertiesMap} from "../../../utils/WidgetFactory";
import {fontSizeOptions} from "../../../pages/Editor/ThemePropertyPane/controls/ThemeFormControl";
import {FontStyleTypes} from "constants/WidgetConstants";
import {EvaluationSubstitutionType} from "../../../entities/DataTree/types";
import {SelectWidgetProps} from "../../../widgets/SelectWidget/widget";
import {isAutoLayout} from "../../../utils/autoLayout/flexWidgetUtils";
import {LabelPosition} from "../../../components/constants";
import {Alignment} from "@blueprintjs/core";
import type {BaseInputWidgetProps} from "../../../widgets/BaseInputWidget/widget";
import contentConfig from "./contentConfig";
import styleConfig from "./styleConfig";
import { EventType } from "../../../constants/AppsmithActionConstants/ActionConstants";

class TRadio extends TaroWidget<TRadioWidgetProps, WidgetState> {
  constructor(props: TRadioWidgetProps) {
    super(props);
  }
  static getAutocompleteDefinitions(): AutocompletionDefinitions {
    return {
      value: "string",
      isVisible: DefaultAutocompleteDefinitions.isVisible,
    };
  }
  static getPropertyPaneEventsConfig() {
    return super.getWidgetEvents("AtRadioWidget");
  }

  static getPropertyPaneContentConfig = contentConfig;
  static getPropertyPaneStyleConfig = styleConfig;

  static getDerivedPropertiesMap(): DerivedPropertiesMap {
    return {
      getValue: `{{ this.value }}`,
      isValid: `{{ this.isRequired ? !!this.value : true }}`
    };
  }

  static getStylesheetConfig(): Stylesheet {
    return {
      borderRadius: "{{appsmith.theme.borderRadius.appBorderRadius}}",
      boxShadow: "none",
      bgColor: "{{appsmith.theme.form.inputBorder.bgColor}}",
      fontSize: "{{appsmith.theme.form.label.fontSize}}",
      color: "{{appsmith.theme.form.label.fontColor}}",
      fontStyle: "{{appsmith.theme.form.label.fontStyle}}",
      inputFontSize: "{{appsmith.theme.form.inputText.fontSize}}",
      inputColor: "{{appsmith.theme.form.inputText.fontColor}}",
      inputFontStyle: "{{appsmith.theme.form.inputText.fontStyle}}",
    };
  }
  updateWidgetProperty = (propertyValues: string) => {
    if(propertyValues != this.props.value){
      this.onOptionChange();
      this.props.updateWidgetMetaProperty("value", propertyValues);
    }
  }
  onOptionChange = ()=>{
    if(this.props.onOptionChange){
      super.executeAction({
        triggerPropertyName: "onOptionChange",
        dynamicString: this.props.onOptionChange,
        event: {
          type: EventType.ON_OPTION_CHANGE,
        }
      })
    }
  }

  getPageView() {
    return (
      <TRadioWidget {...this.props} updateWidgetProperty={this.updateWidgetProperty} />
    );
  }


  static getWidgetType(): WidgetType {
    return "AT_RADIO_WIDGET";
  }
}

export interface TRadioWidgetProps extends WidgetProps {
  value: any[];
  label: string;
  onClick?: any;
  borderRadius: string;
  boxShadow?: string;
}

export default TRadio;
